import React from 'react';
import PropTypes from 'prop-types';

import { parseReflectionText } from '../../utils/reflectionFormatter';
import { normalizeTaskReflectionText } from '../../utils/taskReflectionNormalize';
import './FormattedReflection.css';

/**
 * FormattedReflection Component
 * Displays AI-generated reflection with elegant formatting similar to professor notes
 */
const FormattedReflection = ({ text, className = '' }) => {
  if (!text) return null;

  const normalizedText = normalizeTaskReflectionText(text);
  const sections = parseReflectionText(normalizedText);

  if (sections.length === 0) {
    // Fallback to simple display if parsing fails
    return (
      <div className={`formatted-reflection ${className}`}>
        <div className="reflection-content-simple">{normalizedText}</div>
      </div>
    );
  }

  return (
    <div className={`formatted-reflection ${className}`}>
      {sections.map((section, sectionIdx) => (
        <div key={sectionIdx} className="reflection-section-block">
          <h4 className="reflection-section-title">
            <span className="section-number">{sectionIdx + 1}.</span>
            {section.title}
          </h4>
          <div className="reflection-section-content">
            {section.content.map((item, itemIdx) => {
              if (item.type === 'list') {
                return (
                  <ul key={itemIdx} className="reflection-list-elegant">
                    {item.items.map((listItem, listIdx) => (
                      <li key={listIdx} className="reflection-list-item">
                        {listItem.label && (
                          <strong className="list-item-label">{listItem.label}:</strong>
                        )}
                        <span className="list-item-text">{listItem.text}</span>
                      </li>
                    ))}
                  </ul>
                );
              }

              if (item.type === 'paragraph') {
                return (
                  <p key={itemIdx} className="reflection-paragraph">
                    {item.text}
                  </p>
                );
              }

              return null;
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

FormattedReflection.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

export default FormattedReflection;
